import React from "react";
import Modal from "react-bootstrap/Modal";
import { useDispatch } from "react-redux";
import { UserActions } from "../../../redux/actions/user.actions";
import { CancelIcon } from "../../../assets/images/icon/iconsProvider";

const ModalApprovedRejected = (props) => {
  const dispatch = useDispatch();

  return (
    <>
      <Modal
        className={props.customClass}
        size={props.size}
        centered={true}
        scrollable={props.scrollable}
        show={props.show}
        onHide={() => dispatch(UserActions.OpenAppRejModal(false))}
      >
        <Modal.Body>
          <span
            onClick={(e) => dispatch(UserActions.OpenAppRejModal(false))}
            className={props.closeBtnClasses || "modal-close-icon"}
          >
            <CancelIcon />
          </span>
          {props.children}
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ModalApprovedRejected;
